import { render, staticRenderFns } from "./kehuixy.vue?vue&type=template&id=590ae296&scoped=true"
import script from "./kehuixy.vue?vue&type=script&lang=js"
export * from "./kehuixy.vue?vue&type=script&lang=js"
import style0 from "./kehuixy.vue?vue&type=style&index=0&id=590ae296&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ae296",
  null
  
)

export default component.exports